import { CommonModule } from '@angular/common';
import { Component, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { FieldWrapper, FormlyFieldConfig } from '@ngx-formly/core';

export function formilyIconExtension(field: FormlyFieldConfig) {
  if (!field.props || (field.wrappers && field.wrappers.indexOf('addons') !== -1)) {
    return;
  }

  if (field.props['addonLeft'] || field.props['addonRight']) {
    field.wrappers = [...(field.wrappers || []), 'addons'];
  }
}

@Component({
    selector: 'formly-wrapper-addons',
    imports: [CommonModule, MatIconModule],
    template: `
    <ng-template #matPrefix>
      <mat-icon *ngIf="props['addonLeft']?.icon">{{ props['addonLeft'].icon }}</mat-icon>
    </ng-template>

    <ng-container #fieldComponent></ng-container>

    <ng-template #matSuffix>
      <mat-icon *ngIf="props['addonRight']?.icon">{{ props['addonRight'].icon }}</mat-icon>
    </ng-template>
  `
})
export class FormilyWrappedIconComponent extends FieldWrapper implements AfterViewInit {
  @ViewChild('matPrefix', { static: true }) matPrefix!: TemplateRef<MatPrefix>;
  @ViewChild('matSuffix', { static: true }) matSuffix!: TemplateRef<MatSuffix>;

  ngAfterViewInit() {
    if (this.matPrefix) {
      // Note: for text use `textPrefix` property (only in Angular Material >= 15)
      this.props['prefix'] = this.matPrefix;
    }

    if (this.matSuffix) {
      // Note: for text use `textSuffix` property (only in Angular Material >= 15)
      this.props['suffix'] = this.matSuffix;
    }
  }
}
